module.exports = {"360430100":"龙城镇","360430101":"棉船镇","360430102":"马垱镇","360430103":"芙蓉墩镇","360430104":"定山镇","360430105":"天红镇","360430106":"杨梓镇","360430107":"东升镇","360430108":"瀼溪镇","360430109":"黄花镇","360430200":"太平关乡","360430201":"黄岭乡","360430202":"浩山乡","360430403":"建筑材料厂","360430404":"水产养殖场","360430500":"太泊湖农业综合开发区","360430501":"上十岭综合垦殖场","360430502":"芙蓉农场","360430503":"棉科所","360430504":"棉花原种场国营分场","360430505":"太泊湖水产养殖场","360430506":"黄乐林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360430.json
// module id = 1388
// module chunks = 0